export const BATCH_THRESHOLD_SECONDS = 60;
export const INITIAL_BATCH_WINDOW_SECONDS = 20;
export const FOLLOW_UP_BATCH_WINDOW_SECONDS = 40;
export const BATCH_WINDOW_SECONDS = INITIAL_BATCH_WINDOW_SECONDS;

export const getPlannedTotalFrames = (durationSec, fps) => {
    if (!Number.isFinite(durationSec) || durationSec <= 0 || !Number.isFinite(fps) || fps <= 0) {
        return 0;
    }

    return Math.max(1, Math.floor(durationSec * fps) + 1);
};

export const formatFFmpegTime = (seconds) => {
    if (!Number.isFinite(seconds) || seconds < 0) {
        return '0.000';
    }

    return seconds.toFixed(3);
};

export const buildExtractionPlan = (
    durationSec,
    fps,
    thresholdSec = BATCH_THRESHOLD_SECONDS,
    initialWindowSec = INITIAL_BATCH_WINDOW_SECONDS,
    followUpWindowSec = FOLLOW_UP_BATCH_WINDOW_SECONDS
) => {
    const totalFrames = getPlannedTotalFrames(durationSec, fps);
    const plannedDurationSec = totalFrames > 0 ? (totalFrames - 1) / fps : 0;

    if (totalFrames === 0) {
        return {
            requestedDurationSec: durationSec,
            plannedDurationSec: 0,
            totalFrames: 0,
            shouldBatch: false,
            batches: [],
        };
    }

    const shouldBatch = plannedDurationSec > thresholdSec;

    if (!shouldBatch) {
        return {
            requestedDurationSec: durationSec,
            plannedDurationSec,
            totalFrames,
            shouldBatch: false,
            batches: [
                {
                    index: 0,
                    startFrame: 0,
                    frameCount: totalFrames,
                    startSec: 0,
                    durationSec: plannedDurationSec,
                    outputPattern: 'frame_%04d.png',
                    frameRegex: /^frame_\d{4}\.png$/,
                },
            ],
        };
    }

    const batches = [];

    for (let startFrame = 0, index = 0; startFrame < totalFrames; index += 1) {
        const windowSec = index === 0 ? initialWindowSec : followUpWindowSec;
        const framesPerBatch = Math.max(1, Math.round(windowSec * fps));
        const frameCount = Math.min(framesPerBatch, totalFrames - startFrame);
        const batchPrefix = `batch_${String(index).padStart(4, '0')}`;

        batches.push({
            index,
            startFrame,
            frameCount,
            startSec: startFrame / fps,
            durationSec: frameCount / fps,
            outputPattern: `${batchPrefix}_frame_%04d.png`,
            frameRegex: new RegExp(`^${batchPrefix}_frame_\\d{4}\\.png$`),
        });

        startFrame += frameCount;
    }

    return {
        requestedDurationSec: durationSec,
        plannedDurationSec,
        totalFrames,
        shouldBatch: true,
        batches,
    };
};
